import React                from 'react';
import { Box }              from '@mui/material';
import SfondoLogin          from '../images/sfondoLogin.png';
import RegisterComponent    from '../components/RegisterComponent';

const Register = () => {
return (
    <Box
    sx={{
        position: 'relative',
        height: '100vh',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    }}
    >
    {/* Immagine di sfondo */}
    <Box
        component="img"
        src={SfondoLogin}
        alt="Sfondo Login"  
        sx={{
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        objectFit: 'cover',
        zIndex: -1, 
        }}
    />

    {/* Box per il contenuto del LoginComponent */}
    <Box
        sx={{
        backgroundColor: 'rgba(255, 255, 255, 0.8)',
        borderRadius: '20px',
        p: 3,
        boxShadow: 3, 
        }}
    >
        <RegisterComponent />
    </Box>
    </Box>
);
};

export default Register;
